import { FillScreen } from "@/components/Layout";
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_staff/apps/_list/alerts/_alerts/shadow-it/_shadow-it",
)({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <FillScreen className="flex flex-col gap-4">
      <Outlet />
    </FillScreen>
  );
}
